import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

function BasicInstallation({ formData, setFormData, isDisable }) {
  const [plantList, setPlantList] = useState([]);
  const [shippingLocations, setShippingLocations] = useState([]);

  useEffect(() => {
    getPlantList();
    getOfficeLocation();
  }, []);

  const getPlantList = () => {
    utils
      .callAPI("get", `/purchaseorder/plant/list`)
      .then((res) => {
        setPlantList(res?.result || []);
      })
      .catch(() => {
        setPlantList([]);
      });
  };

  const getOfficeLocation = () => {
    utils
      .callAPI("get", `/sales/getLocationList`)
      .then((res) => {
        setShippingLocations([
          { id: "", name: "Select Location..." },
          ...res.result,
        ]);
      })
      .catch(() => {
        setShippingLocations([]);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "poValue" && !/^\d*\.?\d{0,2}$/.test(value)) {
      return;
    }

    if (["equipmentCount", "poNumber"].includes(name) && !/^\d*$/.test(value)) {
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const shippingLocationOptions = shippingLocations.map((location) => ({
    value: location.id,
    label: location.name,
  }));
  return (
    <>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="plantLocation"
            label="Plant"
            className="floating-label-fancy"
          >
            <RB.Form.Select
              name="plantLocation"
              value={formData.plantLocation}
              onChange={handleChange}
              required
              disabled={isDisable}
            >
              <option value="">Select Plant</option>
              {plantList.map((plant) => (
                <option key={plant.id} value={plant.id}>
                  {plant.plant_name}
                </option>
              ))}
            </RB.Form.Select>
          </RB.FloatingLabel>
        </div>
      </RB.Col>
      <RB.Col md={6} className="mt-3">
        <Select
          inputId="shippingLocation"
          name="shippingLocation"
          className="bom-productName-select"
          classNamePrefix="shipping-location"
          value={
            shippingLocationOptions.find(
              (opt) => opt.value === formData.shippingLocation
            ) || null
          }
          onChange={(selectedOption) =>
            handleChange({
              target: {
                name: "shippingLocation",
                value: selectedOption?.value || "",
              },
            })
          }
          options={shippingLocationOptions}
          placeholder="Select Location..."
          isClearable
          isSearchable
          isDisabled={isDisable}
        />
      </RB.Col>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="equipmentName"
            label="Name of Equipment"
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="equipmentName"
              placeholder="Name of Equipment"
              value={formData.equipmentName}
              onChange={handleChange}
              required
              disabled={isDisable}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="brand"
            label="Make / Brand"
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="brand"
              placeholder="Make / Brand"
              value={formData.brand}
              onChange={handleChange}
              disabled={isDisable}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="equipmentCount"
            label="No. of Equipments"
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="equipmentCount"
              placeholder="No. of Equipments"
              value={formData.equipmentCount}
              onChange={handleChange}
              disabled={isDisable}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="cerNumber"
            label="CER No."
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              disabled={isDisable}
              name="cerNumber"
              placeholder="CER No."
              value={formData.cerNumber}
              onChange={handleChange}
              required
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="supplierName"
            label="Name of the Supplier"
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="supplierName"
              placeholder="Name of the Supplier"
              disabled={isDisable}
              value={formData.supplierName}
              onChange={handleChange}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="poNumber"
            label="P.O. No."
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="poNumber"
              placeholder="P.O. No."
              disabled={isDisable}
              value={formData.poNumber}
              onChange={handleChange}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
      <RB.Col md={6}>
        <div className="mt-3">
          <DatePicker
            selected={formData.poDate}
            onChange={(date) => setFormData({ ...formData, poDate: date })}
            className="form-control"
            disabled={isDisable}
            dateFormat="dd-MM-yyyy"
            placeholderText="Select Po Date"
          />
        </div>
      </RB.Col>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="poValue"
            label="PO Value (Gross) Rs."
            className="floating-label-fancy"
          >
            <RB.Form.Control
              disabled={isDisable}
              type="text"
              name="poValue"
              placeholder="PO Value (Gross) Rs."
              value={formData.poValue}
              onChange={handleChange}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="engineeringCode"
            label="Assets Code"
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="asset_code_no"
              placeholder="Assets Code"
              value={formData.asset_code_no}
              disabled={isDisable}
              onChange={handleChange}
              required
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>

      <RB.Col md={6}>
        <div className="mb-3">
          <RB.FloatingLabel
            controlId="engineeringCode"
            label="Engineering Grouping Code"
            className="floating-label-fancy"
          >
            <RB.Form.Control
              type="text"
              name="engineeringCode"
              placeholder="Engineering Grouping Code"
              value={formData.engineeringCode}
              disabled={isDisable}
              onChange={handleChange}
            />
          </RB.FloatingLabel>
        </div>
      </RB.Col>
    </>
  );
}

export default BasicInstallation;
